import React, { memo, useCallback } from 'react';

import { Button } from 'antd';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import pageUrls from '@/constants/pageUrls';
import Alert, { ALERT_TYPE } from '@/views/alerts/Alert';

const CompanyAddSuccessed = props => {
  const { action = true } = props;

  const { t } = useTranslation();
  const history = useHistory();

  const handleClickButton = useCallback(() => {
    history.push(pageUrls.TENDERS.LIST);
  }, [history]);

  return (
    <Alert
      type={ALERT_TYPE.SUCCESS}
      message={t('alert.company-add-successed.title')}
      description={t('alert.company-add-successed.description')}
      action={
        action && (
          <Button shape="round" type="primary" onClick={handleClickButton}>
            {t('alert.company-add-successed.button')}
          </Button>
        )
      }
    />
  );
};

export default memo(CompanyAddSuccessed);
